import { Form as FormAntd, FormInstance, Typography } from "antd"
import { FC } from "react";

interface IFormDebugger {
    Form?: typeof FormAntd;
    form?: FormInstance;
}
export const FormDebugger: FC<IFormDebugger> = ({
    Form,
    form
}) => {
    return (
        <>
            {
                Form && (
                    <Form.Item noStyle shouldUpdate>
                        {() => (
                            <Typography>
                                <pre>{JSON.stringify(form?.getFieldsValue(), null, 2)}</pre>
                            </Typography>
                        )}
                    </Form.Item>
                )
            }
        </>
    )
}